import { Box, Link, styled } from '@mui/material'
import SnowflakeIcon from 'assets/icons/logos-connections-snowflake.svg?react'
import CartoIcon from 'assets/icons/logos-data-provider-carto.svg?react'
import CheckIcon from 'assets/icons/icon-action-check-circle-outline.svg?react'
import LinkIcon from 'assets/icons/link.svg?react'
import { FormattedMessage } from 'react-intl'
import { Typography } from '@carto/meridian-ds/components'

const StyledLink = styled(Link)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
  fontSize: theme.spacing(1.5),
  fontWeight: 600
}))

const ConnectionWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  flexDirection: 'column',
  maxWidth: theme.spacing(7.5),
  overflow: 'hidden',
  height: theme.spacing(13.85),
  justifyContent: 'center'
}))

const SmallCheckIcon = styled(CheckIcon)(({ theme }) => ({
  width: theme.spacing(2.5),
  height: theme.spacing(2.5),
  position: 'absolute',
  top: '50%',
  transform: `translateY(calc(-100% - ${theme.spacing(2)}))`
}))

const RoundedBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.spacing(1.25),
  width: theme.spacing(15),
  height: theme.spacing(13.85),
  boxShadow: '0 1px 4px 0 rgba(44, 44, 44, 0.16)'
}))

function PartnerConnectDialogContent() {
  return (
    <Box pt={3}>
      <Typography variant="body2">
        <strong>
          <FormattedMessage id="account.sfConnectDialog.headlineOne" />
        </strong>
      </Typography>
      <Typography variant="body2" mt={2}>
        <FormattedMessage id="account.sfConnectDialog.paragraphOne" />
      </Typography>
      <Box display="flex" flexDirection="row">
        <Box display="flex" flexDirection="column" flex={0.6}>
          <Typography variant="body2" mt={3} mb={1}>
            <strong>
              <FormattedMessage id="account.sfConnectDialog.headlineTwo" />
            </strong>
          </Typography>
          <StyledLink
            href={'https://docs.carto.com/data-and-analysis/analytics-toolbox-for-snowflake'}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="account.sfConnectDialog.docs.first" />
          </StyledLink>
          <StyledLink
            href={'https://maps.carto.io/carto-snowflake-grocery/index.html'}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="account.sfConnectDialog.docs.second" />
          </StyledLink>
          <StyledLink
            href={'https://go.carto.com/webinars/spatial-extension-snowflake'}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="account.sfConnectDialog.docs.third" />
          </StyledLink>
        </Box>
        <Box flex={0.5} display="flex" alignItems="center" justifyContent="center">
          <RoundedBox>
            <CartoIcon />
          </RoundedBox>
          <ConnectionWrapper display="flex" alignItems="center">
            <SmallCheckIcon />
            <LinkIcon />
          </ConnectionWrapper>
          <RoundedBox>
            <SnowflakeIcon />
          </RoundedBox>
        </Box>
      </Box>
    </Box>
  )
}

export default PartnerConnectDialogContent
